var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: { name: "post-form", width: 0, "click-to-close": false },
      on: { "before-open": _vm.modalBeforeOpen, closed: _vm.modalClosed }
    },
    [
      _c(
        "div",
        {
          staticClass: "modal show modal__post_form modal__new_design",
          class: { "share-post-form-modal": _vm.isSharingPost }
        },
        [
          _c(
            "section",
            [
              _vm.modalOpened
                ? _c("PostForm", {
                    attrs: { post_init: _vm.post },
                    on: { close: _vm.hide }
                  })
                : _vm._e()
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }